import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StateContext = createContext(null);

export function StateProvider({ children }) {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const data = await api.getState();
    setState(data);
    return data;
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const calculate = useCallback(async (amount, opts) => {
    const sprint = await api.calculate(amount, opts);
    await refresh();
    return sprint;
  }, [refresh]);

  const accept = useCallback(async (id) => {
    const sprint = await api.accept(id);
    await refresh();
    return sprint;
  }, [refresh]);

  const protect = useCallback(async (id) => {
    const sprint = await api.protect(id);
    await refresh();
    return sprint;
  }, [refresh]);

  const confirm = useCallback(async (id, payments) => {
    const sprint = await api.confirm(id, payments);
    await refresh();
    return sprint;
  }, [refresh]);

  const reset = useCallback(async () => {
    const data = await api.reset();
    setState(data);
    return data;
  }, []);

  const saveFoundation = useCallback(async (payload) => {
    const data = await api.saveFoundation(payload);
    setState(data);
    return data;
  }, []);

  const value = { state, loading, refresh, calculate, accept, protect, confirm, reset, saveFoundation };
  return <StateContext.Provider value={value}>{children}</StateContext.Provider>;
}

export const useAppState = () => {
  const ctx = useContext(StateContext);
  if (!ctx) throw new Error("useAppState must be used within StateProvider");
  return ctx;
};
